// src/DB_Url.js
// export const SERVER_URL = "http://localhost:5000"; // For local development;
// export const SERVER_URL = 'https://vcontrol.pythonanywhere.com'; 
export const SERVER_URL = 'https://api.replan360.com'; // For production deployment